module.exports = __webpack_public_path__ + "static/starter-business-e56f26252440f70e109a753406de1983.png";